import { render, staticRenderFns } from "./PartnerOffers.vue?vue&type=template&id=50749e9a&scoped=true"
import script from "./PartnerOffers.vue?vue&type=script&lang=ts"
export * from "./PartnerOffers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50749e9a",
  null
  
)

export default component.exports